import { styled } from "@mui/material";

export const Page = styled('div')(({ theme }) => ({
  background: theme.palette.background.default,
  height: "100vh",
  overflow: "hidden",
  position: "relative"
}))